<template>
    <div class="card mx-3">
      <div v-if="!this.userInfo.onlySelf && $store.state.currentCensusPeriod">
        <dashboard />
        <!-- <select-locale class="ml-auto mr-5"/> -->
      </div>
      <!-- <home-menu /> -->
    </div>
</template>

<script>
  import Dashboard from '../components/dashboard/Dashboard.vue'
  // import HomeMenu from '../components/dashboard/homeMenu.vue'
  import {routes} from "../services/routing.service.js";
  import EsepService from "../services/esep.service";
  import { handleApiError } from '../services/error.service';
  // import SelectLocale from '../components/SelectLocale.vue'

export default {
  name: 'home',
  components: {
    // SelectLocale,
    Dashboard,
    // HomeMenu      
  },
  props:{
      username: String,
  },
  data() {
    return {
      routes: routes.routes,
      userInfo: {}
    }
  },
  mounted() {
    EsepService.getUserInfo(this.$store.state.auth.username).then(
      (response) => {
        this.userInfo = response.data;
        this.$store.state.userInfo = this.userInfo;

        if (this.userInfo.onlySelf){
          location.replace(`${routes.achievement.progress}/${this.userInfo.id}`);
        }

        this.fetchAccessibleUnits();
      }
    );
    this.getCurrentCensusPeriod();
  },
  methods: {
    handleError(errors) {
      errors.forEach(error => {
        error.message = this.$t(`error.${error.code}`);
      })
      this.errors = errors;
      this.popAlert = errors.length>0;
    },
    fetchAccessibleUnits(){
      EsepService.getAccessibleUnits(null).then(
          (response) => {
            this.usersAdminableUnits = response.data.ADMIN_UNIT;
            this.$store.state.usersAdminableUnits = this.usersAdminableUnits;
            this.usersModableUnits = response.data.MOD_UNIT;
            this.$store.state.usersModableUnits = this.usersModableUnits;
            this.usersAccessibleUnits = response.data.VIEW_UNIT;
            this.$store.state.usersAccessibleUnits = this.usersAccessibleUnits;
          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.$emit('error:api', errorMessage);
          }
      );
    },
    getCurrentCensusPeriod() {
      EsepService.getCurrentCensusPeriod().then(
        (response) => {
          let ccp = response.data;
          this.$store.state.currentCensusPeriod = ccp;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    }
  }
}
</script>